<div class="footer-3a">
  <app-guarantee-shield></app-guarantee-shield>
</div>
